{
  "commons": {
    "incomplete": "Puutteellinen",
    "requiredQuestion": "Pakollinen",
    "completed": "Valmis",
    "invalid": "Virheellinen",
    "and": "ja",
    "month": "kuukausi",
    "month_other": "kuukautta",
    "year": "vuosi",
    "year_other": "vuotta",
    "save": "Tallenna",
    "edit": "Muokkaa",
    "delete": "Poista",
    "viewFile": "Katso tiedosto",
    "downloadFile": "Lataa tiedosto",
    "support": {
      "assignedToAdminUser": "<b>Kysymyksiä?</b><br/> Neuvonantajasi {{firstName}} auttaa mielellään: <a>{{mobilePhoneNumber}}</a>",
      "default": "<b>Kysymyksiä?</b><br/> Ota yhteyttä: <a>{{mobilePhoneNumber}}</a>",
      "contactUs": "Ota yhteyttä: "
    },
    "processSteps": {
      "improveLoanApplication": "Syötä tiedot ja lähetä",
      "improveLoanApplicationSubheading": "{{ numAnswered }} / {{ numQuestions }} vastattu",
      "compareBids": "Valitse tarjouksista",
      "bidSelected": "Vastaanota varat"
    },
    "app": {
      "title": {
        "loanAppForm": "Yrityslainahakemus",
        "factoringAppForm": "Laskurahoitushakemus",
        "preliminaryBidForm": "Arvioi luottorajasi",
        "realEstateForm": "Kiinteistölainahakemus",
        "leasingForm": "Leasing-hakemus",
        "improveApp": "Paranna hakemustasi",
        "dashboard": "Dashboard",
        "selectedLenderResponse": "Kysymykset lainanantajalta",
        "advice": "Neuvonta",
        "application": "Hakemus"
      }
    },
    "contactCustomerServiceDialog": {
      "support": "Asiakastuki",
      "contactCustomerService": "Ota yhteyttä asiakaspalveluun",
      "needHelp": "Tarvitsetko apua?",
      "contactUs": "Ota yhteyttä asiakaspalveluumme.",
      "customerServiceOpen": "Auki  ",
      "customerServiceClosed": "Asiakaspalvelu suljettu",
      "customerServiceClosedMessage": "Asiakaspalvelu suljettu – Voitte soittaa meille {{openHours}} tai ota yhteyttä sähköpostitse",
      "contactYourAdvisor": "Ota yhteyttä neuvonantajaasi ({{advisorName}})",
      "bookMeetingWithAdvisor": "Varaa tapaaminen neuvonantajasi kanssa"
    }
  },
  "login": {
    "heading": "Kirjaudu sisään",
    "canceledTitle": "Kirjautuminen perutttu",
    "startBankId": "Tunnistaudu pankkitunnuksilla",
    "bankIdGeneric": "Mobiili BankID",
    "bankIdOnAnotherDevice": "BankID toisella laitteella",
    "bankIdOnThisDevice": "Pankkitunnistautuminen tällä laitteella",
    "bankIdOnTestFlow": "Sosiaaliturvatunnuksella (vain testausta varten)",
    "bankIdQrCodeManual": {
      "title": "Toimi näin",
      "step1": "Käynnistä Mobilt BankID -sovellus",
      "step2": "Klikkaa QR-kuvaketta sovelluksessa",
      "step3": "Kohdista kamera täällä näytöllä näkyvään QR-koodiin",
      "step4": "Tunnistaudu sovelluksessa"
    },
    "autostart": {
      "title": "Yrittää käynnistää BankID-sovelluksen",
      "description": "Jos sinulla ei ole BankID-sovellusta asennettuna samalle laitteelle, jota käytät, klikkaa sitten alla olevaa 'BankID toisella laitteella'."
    },
    "writeSecurityCode": "Tunnistaudu sovelluksessa",
    "giveValidSSN": "Anna kelvollinen henkilötunnus",
    "noApplicationForSSN": "Tällä käyttäjällä ei ole hakemuksia",
    "pleaseWait": "Odota",
    "SSN": "HETU",
    "SSNHelper": "Henkilötunnus käytetään varmistamaan, että tietojasi suojellaan luvattomalta pääsyltä.",
    "continue": "Jatka",
    "loginCancelled": "Olet päättänyt keskeyttää kirjautumisen.",
    "loginError": "Kirjautumisesi on keskeytetty. Yritä uudelleen. Jos ongelma jatkuu, ota yhteyttä asiakaspalveluun.",
    "abortLogin": "Peruuta kirjautuminen",
    "back": "Takaisin"
  },
  "errors": {
    "404": {
      "heading": "Sivua ei löytynyt",
      "subheading": "Valitettavasti emme löytäneet etsimääsi sivua.",
      "cta": {
        "user": "Takaisin",
        "notUser": "Takaisin kotisivulle"
      }
    }
  },
  "openBankingData": {
    "isCompany": {
      "title": "Valitse yritystilit seuraavassa vaiheessa",
      "cta": {
        "notOnboarded": "Jaa tiliote",
        "isOnboarded": "Jaa toinen tiliote"
      }
    },
    "connectBank": "Yhdistä yrityspankkisi",
    "clickToConnectBank": "Klikkaa alhaalta yhdistääksesi yrityspankkiisi",
    "successfullyConnected": "Tilisi on yhdistetty onnistuneesti.",
    "shareBankStatement": "Jaa tiliote",
    "shareAnotherBankStatement": "Jaa toinen tiliote",
    "selectRevenueBank": "Valitse pankki, johon yrityksesi saa maksuja asiakkailta.",
    "showAllBanks": "Näytä kaikki pankit",
    "selectRevenueAccounts": "Valitse tilit, joille vastaanotat asiakasmaksuja",
    "confirmRevenueAccounts": "Vahvista tilit, jolle saat tuloja",
    "selectAtLeastOneAccount": "Valitse vähintään yksi tili",
    "isPrivate": {
      "optional": "Valinnainen: ",
      "title": "Yhdistä pankkitilisi vahvistaaksesi tulosi.",
      "cta": "Jaa yksityistilien otteet"
    },
    "chooseBank": "Valitse pankki",
    "showMore": "Näytä lisää",
    "success": "Tiliotteet on haettu",
    "error": "Jokin meni pieleen. Yritä uudelleen tai ota yhteyttä asiakaspalveluun",
    "selectionError": "Jokin meni pieleen. Varmista, että selain ei estä ponnahdusikkunoita/uutta välilehteä."
  },
  "slider": {
    "enterValueManually": "Kirjoita",
    "backToSlider": "Takaisin liukusäätimeen"
  },
  "applicationForm": {
    "startOver": "Aloita alusta",
    "testimonials": {
      "smallBusinessesTrustUs": "Pienet yritykset luottavat meihin",
      "saltoMarin": {
        "organization": "Saltö Marin",
        "type": "KIINTEISTÖLAINA",
        "turnover": "LIIKEVAIHTO:",
        "loan": "LAINA:",
        "text": "Minusta eri pankkien ehtojen vertailuprosessi oli mainio, varsinkin nyt, kun suuret pankit ovat tiukempia yritylainojen suhteen. Prosessi Kreditan kautta säästää minulle yrityksen omistajana paljon aikaa verrattuna siihen, että hakisin itse yrityslainaa erikseen jokaisesta pankista.",
        "author": "Mats Lindqvist, Omistaja"
      },
      "willBrand": {
        "organization": "Will Brand",
        "type": "KÄYDÄ KAUPPAA",
        "turnover": "LIIKEVAIHTO:",
        "loan": "LAINA:",
        "text": "Kasvumme odotettua nopeammin ja yrityksille suunnattu verkkokauppamme tarvitsi vauhtia samalla kun tarvitsimme kahden suuren syysprojektin tuotannon ennakkomaksuja. Krealla se toimii yllättävän nopeasti ja palveluhenkilöstöltä saa mukavaa ja hyvää kohtelua. Prosessi oli paljon sujuvampi verrattuna vanhanaikaiseen \"pankkimaailmaan\".",
        "author": "Pierre Gasslander, Omistaja"
      },
      "elfantminer": {
        "organization": "Elfantminer",
        "type": "SIJAINTI: LOHJA",
        "turnover": "LAINANANTAJA: SME FINANCE",
        "loan": "LAINA:",
        "text": "Kilpailutus oli helppo tehdä ja Kreditan kautta saatujen lainatarjousten ehdot olivat helppo ymmärtää. Lainaneuvotteluissa syntyi tunne, että kaikki osapuolet olivat aidosti kiinnostuneita yhtiön liiketoiminnasta ja valmiita hakemaan ratkaisun yhtiön tarpeita vastaavaksi. Kreditan rahoitusneuvoja piti pyörät pyörimässä ja rahat saatiin tilille muutamassa viikossa.",
        "author": "Kristian Savela, Perustaja"
      }
    },
    "common": {
      "startApplicationHeading": "Hae tarjoukset",
      "startApplicationSubheading": "Täytä tietosi",
      "customerCompanyLabel": "Asiakkaan yritys",
      "backToHome": "Takaisin kotisivulle",
      "getStarted": "Aloita",
      "privacyPolicy": "tietosuojakäytäntömme",
      "privacyPolicyConsent": "Hyväksyn, että {{company}} käsittelee <1>henkilötietojani</1>",
      "businessNotFoundContactSupport": "Etkö löydä yritystäsi? ",
      "applicationExists": "Näyttää siltä, että sinulla on jo olemassa oleva sovellus.",
      "loginToApplication": "Kirjaudu sovellukseen",
      "limitedCompanyConfirmation": "Osakeyhtiö",
      "customer": "Asiakas",
      "partner": "Sinä / Yhteistyökumppani",
      "back": "Takaisin",
      "continue": "Jatka",
      "kreaFullName": "Krea Technology AB:ta",
      "kreditaFullName": "Kredita Oy",
      "kreditaIsPartOf": "on osa",
      "kreditaRegisteredBy": "joka on valtuutettu ja rekisteröity Ruotsin finanssivalvonnan toimesta",
      "anyQuestions": "Onko sinulla kysymyksiä?",
      "happyToHelp": "Rahoitusneuvojamme auttavat sinua mielellään kaikissa rahoitukseen liittyvissä kysymyksissä",
      "yourPersonalAdvisor": "Henkilökohtainen neuvonantajasi: {{advisorName}}",
      "reachOutToYourAdvisor": "Ole yhteydessä, jos sinulla on kysyttävää rahoituksestasi. Autan mielelläni!",
      "questions": "Kysymyksiä?",
      "callUs": "Soita meille ",
      "or": "tai",
      "writeTo": "lähetä sähköpostia ",
      "primaryPurposeHeading": "Mikä on rahoituksen ensisijainen tarkoitus?",
      "selectMainReason": "Jos sinulla on useita rahoitustarpeita, valitse niistä tärkein",
      "buyOrLeaseAnAsset": "Osta tai vuokraa työkone tai -auto",
      "purchaseOfSupply": "Tarvikkeiden osto",
      "expansion": "Laajentaminen",
      "shortTermLiquidity": "Lyhytaikainen likviditeetti",
      "refinancing": "Jälleenrahoitus",
      "realEstate": "Kiinteistörahoitus",
      "invoiceFinance": "Laskurahoitus",
      "acquisitionFinance": "Yrityskaupan rahoittaminen",
      "otherReason": "Muu syy",
      "realEstateHeading": "Valitsit kiinteistörahoituksen",
      "realEstateSubheading": "Määrittele rahoituksen käyttötarkoitus tarkemmin?",
      "bridgeFinancing": "Siltarahoitus",
      "projectFinance": "Projektin rahoitus",
      "purchaseNewProperty": "Uuden kiinteistön osto",
      "refinanceALoan": "Lainan uudelleenrahoitus",
      "renovationOfProperty": "Kiinteistön peruskorjaus",
      "otherPropertyFinance": "Muu kiinteistörahoitus",
      "realEstateExtendedHeading": "Ilmoita kiinteistötunnus",
      "invoiceFinanceHeading": "Laskurahoitus valittiin",
      "invoiceFinanceSubheading": "Voitko antaa hieman lisätietoja myyntilaskuistasi?",
      "totalInvoiceValue": "Laskujen kokonaisarvo kuukausittain",
      "valuePlaceholder": "50 000",
      "invoicesAmountPlaceholder": "20",
      "invoicesSuffix": "laskua",
      "numberOfInvoices": "Laskujen määrä kuukaudessa",
      "averagePaymentTime": "Keskimääräinen laskun eräpäivä",
      "days": "päivää",
      "describeLargestInvoices": "Voitko kuvailla kolmea suurinta laskua?",
      "largestThreeInvoices": "Kolme suurinta laskua",
      "largestInvoicesPlaceholder": "Eli yrityksen nimi, toimiala, kuukausittainen määrä ja tietoa myytävästä palvelusta",
      "buyOrLeaseHeading": "Koneen tai laitteen rahoitus/leasing",
      "buyOrLeaseSubheading": "Voitko antaa lisätietoja ostoksestasi?",
      "price": "Hinta (ilman ALV)",
      "objectType": "Kohteen tyyppi",
      "car": "Auto",
      "machine": "Machine",
      "constructionMachine": "rakennuskone",
      "restaurantEquipment": "Ravintolalaitteet",
      "itOfficeEquipment": "IT/toimistolaitteet",
      "retailEquipment": "Vähittäiskaupan laitteet",
      "gymEquipment": "Kuntosalilaitteet",
      "truck": "Kuorma-auto",
      "other": "Muu",
      "uploadOrLinkObject": "Lataa tarjous tai anna linkki kohteeseen",
      "linkPlaceholder": "https://yritys…",
      "offerOrLink": "Tarjous esine(e)lle tai linkki esineeseen",
      "uploadFile": "Lataa tiedosto",
      "linkToObject": "Linkki objektiin",
      "financingAmountHeading": "Kuinka paljon rahoitusta tarvitset?",
      "financingUpTo": "Rahoitusta jopa ",
      "notSureHowMuchToApplyFor": "Etkö ole varma, kuinka paljon sinun pitäisi hakea? ",
      "seeHowMuchYouQualifyFor": "Testaa yrityksesi rahoitettavuuskelpoisuus ",
      "identificationHeading": "Tunnistaudu",
      "weAreObligedToIdentifyYou": "Meidän on viranomaismääräysten mukaan tunnistettava sinut ja varmistettava suhteesi yritykseen: {{companyName}}",
      "noApplicationOrCreditCheck": "Tässä vaiheessa ei tehdä lainahakemusta tai luottotarkistusta.",
      "noApplication": "Lainahakemusta ei luoda tässä vaiheessa.",
      "acceptTermsAndConditions": "Tunnistautumalla hyväksyt <1>käyttöehdot</1>",
      "minimumFinancingAmountValidation": "Pienin haettava summa on {{amount}}"
    },
    "commons": {
      "heading": "Valitse eri pankkien ja lainanantajien tarjouksista",
      "subHeading": "Tässä vaiheessa ei luoda hakemusta tai tarkisteta luottotietoja.",
      "requestedAmountPreLabel": "Lainasumma",
      "requestedAmountLabel": "Valitse summa",
      "exactRequestedAmountButton": "Syötä tarkka summa",
      "exactRequestedAmountPlaceholder": "100 000 {{currency}}",
      "exactRequestedPeriodButton": "Syötä aika",
      "requestedAmountErrors": {
        "invalidAmount": "Valitse summa",
        "typeError": "Käytä vain numeroita",
        "required": "Valitse summa"
      },
      "reasonLabel": "Lainan käyttötarkoitus",
      "reasonPlaceholder": "Valitse käyttötarkoitus",
      "reasonLabelTooltip": "Seuraavassa vaiheessa voit selittää lainan käyttötarkotusta yksityiskohtaisemmin sekä lisätä mahdollisia lisätietoja tai vakuuksia ennen kuin päätät lähettää hakemuksesi.",
      "reasonCategories": {
        "investments": "Investoinnit",
        "working_capital": "Kassavirta",
        "real_estate": "Kiinteistörahoitus",
        "real_estate_description": "Kiinteistön ostoon, uudelleenrahoitukseen, remontointiin, siltarahoitukseen sekä projektikohtaisiin kiinteistöinvestointeihin.",
        "other": "Muu"
      },
      "reasons": {
        "object_financing": {
          "title": "Kone- ja laitehankinta tai leasing",
          "description": "Koneiden, tai muiden yritystoiminnalle välttämättömien laitteiden rahoitus."
        },
        "supply": {
          "title": "Varaston täydentäminen",
          "description": "Varaston kasvattaminen kysynnän vuoksi tai suurten tilausten täyttämiseksi."
        },
        "expansion": {
          "title": "Toiminnan laajentaminen",
          "description": "Pääomaa liiketoiminnan kasvattamiseen, rekrytointeihin tai uusien toimipisteiden avaamiseen."
        },
        "short_term_liquidity": {
          "title": "Käyttöpääoma ja maksuvalmius",
          "description": "Tilapäisten kassavajeiden paikkaaminen ja juoksevien kulujen kattaminen."
        },
        "refinancing": {
          "title": "Uudelleenrahoitus",
          "description": "Nykyisten lainojen korvaaminen tai yhdistäminen parempien ehtojen saamiseksi."
        },
        "invoice_financing": {
          "title": "Laskurahoitus",
          "description": "Vapauta rahaa nopeasti rahoittamalla myyntisaatavat (avoimet laskut)."
        },
        "acquisition_financing": {
          "title": "Yrityskaupan rahoitus",
          "description": "Rahoitus yrityksen tai liiketoiminnan hankintaan."
        },
        "other": {
          "title": "Muu syy",
          "description": "Muut rahoitustarpeet, joita ei ole mainittu listassa."
        },
        "bridge_financing": {
          "title": "Siltarahoitus",
          "description": "Väliaikainen rahoitus, jolla katetaan rahoitustarve siihen asti, kunnes lopullinen rahoitus, päätös tai kauppa vahvistuu."
        },
        "project_financing": {
          "title": "Projektin rahoitus",
          "description": "Tiettyyn hankkeeseen kohdistuva rahoitus, joka maksetaan takaisin projektin tuottamilla tuloilla."
        },
        "purchase_real_estate": {
          "title": "Kiinteistön osto",
          "description": "Rahoitus liikekiinteistön, sijoitusasunnon tai toimitilojen hankintaan."
        },
        "refinance_real_estate_loan": {
          "title": "Kiinteistölainan uudelleenrahoitus",
          "description": "Paranna lainaehtoja tai vapauta pääomaa olemassa olevista kiinteistöistä."
        },
        "renovation_of_property": {
          "title": "Kiinteistön remontointi",
          "description": "Rahoitus rakentamiseen, peruskorjaukseen ja parannustöihin."
        },
        "other_property_finance": {
          "title": "Muu kiinteistörahoitus",
          "description": " Muut kiinteistöihin liittyvät rahoitustarpeet."
        },
        "property": "Kiinteistörahoitus",
        "machine": "Laitteiston rahoitus",
        "consumables": "Rahoitusta yrityksen juokseviin kuluihin (rekrytointi, markkinointi, kulutustavarat)",
        "capital": "Pääomaa, kunnes asiakas maksanut laskut",
        "other_property": "Muu kiinteistörahoitus",
        "project": "Projektirahoitus",
        "new_business": "Uusien yrityskustannusten rahoitus",
        "restoration": "Kiinteistön/tilojen remontointi",
        "season_investment": "Kausi-investointi",
        "vehicle": "Ajoneuvon osto tai kunnostus"
      },
      "reasonErrors": {
        "required": "Käyttötarkoitus vaaditaan"
      },
      "companyNameLabel": "Yrityksesi",
      "companyNamePlaceholder": {
        "FI": "Yritys OY tai 1234567-8"
      },
      "companyNameFindHelp": "Etkö löydä yritystä? Syötä yrityksen Y-tunnus.",
      "companyNameErrors": {
        "orgNumberRequired": "Y-tunnus vaaditaan",
        "orgNumberInvalid": "Syötä kelvollinen Y-tunnus",
        "orgNameRequired": "Yrityksen nimi vaaditaan"
      },
      "companyNameChange": "Muuta",
      "companyNameSelect": "Valitse",
      "companyNamePreloader": "Etsitään...",
      "emailLabel": "Sähköposti",
      "emailPlaceholder": {
        "FI": "kontakti@yritys.fi"
      },
      "emailTooltip": "Tarvitsemme sähköpostiosoitteesi, jotta voimme ottaa sinuun yhteyttä koskien yrityksellesi sopivaa rahoitustarjousta. Voit aina peruuttaa tilauksen, jos et enää halua saada meiltä tietoja.",
      "emailErrors": {
        "invalid": "Virheellinen sähköpostiosoite",
        "required": "Sähköposti vaaditaan",
        "alreadyExist": "Anna toinen sähköpostiosoite",
        "validationError": "Kirjoita voimassa oleva sähköpostiosoite"
      },
      "ssnLabel": "Sosiaaliturvatunnus",
      "ssnPlaceholder": "ppkkvvynnnt",
      "ssnErrors": {
        "invalid": "Virheellinen sosiaaliturvatunnus",
        "required": "Sosiaaliturvatunnus vaaditaan"
      },
      "phoneLabel": "Matkapuhelinnumero",
      "phonePlaceholder": {
        "FI": "050 0000 000"
      },
      "phoneErrors": {
        "invalid": "Puhelinnumero on virheellinen",
        "required": "Puhelinnumero vaaditaan",
        "incorrectLength": "Puhelinnumero on liian lyhyt",
        "containsSpecialCharacters": "Puhelinnumerossa voi olla vain numeroita"
      },
      "consentCheckboxError": "Sinun on hyväksyttävä, että käsittelemme henkilötietojasi",
      "unpaidInvoicesValidation": {
        "unpaidInvoicesEstimatedRequired": "Haluttu summa vaaditaan",
        "unpaidInvoicesEstimatedInvalid": "Vain numeroita",
        "numberOfUnpaidInvoicesRequired": "Likimääräinen määrä vaaditaan",
        "numberOfUnpaidInvoicesInvalid": "Vain numeroita",
        "descriptionUnpaidInvoicesRequired": "Kolmen suurimman laskun kuvaus vaaditaan"
      },
      "identifyCta": "Tunnistaudu ja jatka",
      "tosInfo": "Tunnistautumalla hyväksyt <1>käyttöehdot</1>",
      "loggedInFormCta": "Hae tarjoukset"
    },
    "premium": {
      "heading": "Neuvottelemme pankkien kanssa puolestasi",
      "subHeading": "Luottotarkastusta ei tehdä tässä vaiheessa",
      "requestedAmountLabel": "Pyydetty summa"
    },
    "factoring": {
      "heading": "Vastaanota monia laskurahoitustarjouksia",
      "subHeading": "Luottotarkastusta ei tehdä tässä vaiheessa."
    },
    "preliminaryBid": {
      "heading": "Saa oikeita tarjouksia"
    },
    "realEstate": {
      "heading": "Kilpailuta monia pankkeja ja lainanantajia",
      "subHeading": "Hakemusta tai luottotarkastusta ei tehdä tässä vaiheessa.",
      "fields": {
        "propertyUnitDesignation": {
          "label": "Kiinteistötunnus",
          "tooltip": "Seuraavassa vaiheessa voit lisätä tietoja kiinteistöistä",
          "placeholder": "123-456-7890-1234",
          "errors": {
            "required": "Kiinteistötunnus vaaditaan"
          }
        }
      }
    },
    "leasing": {
      "heading": "Löydä paras leasing-tarjous",
      "fields": {
        "objectType": {
          "label": {
            "appForm": "Kohteen tyyppi",
            "fieldRequest": "Kohteen tyyppi"
          },
          "placeholder": "Valitse kohteen tyyppi",
          "tooltip": "Seuraavassa vaiheessa voit lisätä tietoja rahoitettavasta kohteesta",
          "errors": {
            "required": "Kohteen tyyppi vaaditaan"
          }
        },
        "objectDescription": {
          "label": "Kuvaus",
          "freetext": "Tiedot voivat sisältää: merkki, toimittajan nimi ja kunto (uusi tai käytetty)"
        },
        "amount": {
          "label": "Hinta (ilman ALV.)",
          "placeholder": "450 000 {{currency}}",
          "errors": {
            "required": "Hinta vaaditaan"
          }
        },
        "offer": {
          "label": "Rahoitettavan kohteen myyntiesite tai linkki myyntisivulle",
          "tabs": {
            "link": "Linkki",
            "file": "Tiedosto"
          },
          "links": {
            "link": {
              "label": {
                "appForm": "URL-linkki kohteen myyntisivulle",
                "fieldRequest": "Linkki tiettyyn kohteeseen"
              },
              "placeholder": "https://yritys.fi/leasing-kohde",
              "errors": {
                "empty": "URL link to the object must not be empty",
                "notUrl": "Linkin kohteeseen pitää olla URL-muodossa"
              }
            }
          },
          "errors": {
            "empty": "Lisää tietoa leasing-kohteesta/kohteista"
          }
        }
      }
    },
    "formSwitcher": {
      "label": "Valitse tuote",
      "companyLoanTab": "Yrityslaina",
      "factoringTab": "Laskurahoitus",
      "realEstateLoanTab": "Kiinteistölaina",
      "leasingTab": "Leasing"
    }
  },
  "iaq": {
    "whyImportantHeading": "Miksi pankit ja lainanantajat tarvitsevat näitä tietoja?",
    "questionsList": "Näytä kaikki kysymykset",
    "nextQuestionCta": "Jatka",
    "skipQuestionCta": "Ohita kysymys",
    "previousQuestionCta": "Takaisin",
    "reviewApplicationGoTo": "Seuraava",
    "contactCustomerSupport": "Ota yhteyttä asiakaspalveluun",
    "uploadedFiles": "Ladatut tiedostot",
    "save": "Tallenna",
    "edit": "Muokkaa",
    "add": "Lisää",
    "close": "Valmis",
    "cancel": "Peruuta",
    "progressBar": {
      "steps": "Kysymys {{currentStep}} / {{stepsQty}}",
      "optional": "(Valinnainen)"
    },
    "advice": {
      "digitalAdviceTitle": "Paranna hakemustasi",
      "digitalAdviceSubheading": "Tunnistimme mahdolliset kehityskohteet",
      "manualAdviceSubheading": "Yksi neuvonantajistamme ottaa sinuun yhteyttä yhden arkipäivän sisällä",
      "title": "Yrityksesi on oikeutettu neuvontaan",
      "titleDone": "Yrityksesi on oikeutettu neuvontaan",
      "doYouHaveQuestions": "Onko sinulla kysymyksiä?",
      "applicationAttractiveness": "Hakemuksesi houkuttelevuus",
      "applicationAttractivenessComparableValueTooltip": {
        "paragraph1": "Hakemuksesi houkuttelevuus pohjautuu Kreditan aikaisempien asiakkaiden dataan.",
        "paragraph2": "Arviomme perustuu pääosin yrityksen luottoluokitukseen ja mahdollisten takaajien tietoihin.",
        "paragraph3": "Voit parantaa yrityksesi mahdollisuuksia saada parempia tarjouksia lisäämällä tietoja sekä vakuuksia hakemuukseesi."
      },
      "applicationAttractivenessGrades": {
        "belowAverage": "Alle keskiverto",
        "average": "Keskiverto",
        "excellent": "Erinomainen"
      },
      "provideMoreDetailsWhileWaitingAdviceBypassDisabled": "Vastaa vähintään yhteen kysymykseen lähettääksesi hakemuksen suoraan - vaihtoehtoisesti olemme sinuun yhteydessä 1 arkipäivän sisällä.",
      "provideMoreDetailsWhileWaiting": "Anna lisätietoja sillä välin, kun odotat yhteydenottoa",
      "yourAdvisor": "Neuvonantajasi",
      "yourAdvisorIsHappyToAssist": "Neuvonantajasi auttaa mielellään",
      "improveApplicationWithImprovements": "Paranna hakemustasi hyödyntämällä alla olevia suosituksiamme.",
      "allImprovementsSolved": "Kiitos! Käytit suosituksiamme ja näin sinun pitäisi todennäköisemmin saada hyviä tarjouksia.",
      "allImprovementsDismissed": {
        "title": "Päätit olla hyödyntämättä kaikkia suosituksiamme.",
        "subtitleDigitalAdvice": "Klikkaamalla \"Lähetä ilman parannuksia\", alat vastaanottamaan tarjouksia pian.",
        "subtitleAdvice": "Neuvonantajasi on sinuun yhteydessä 24 tunnin sisällä hakemuksesi parantamiseksi."
      },
      "whyIsScoreNot100%": "Miksi tulokseni ei ole 100%?",
      "whyIsScoreNot100%Modal": {
        "paragraph1": "Hakemuksesi houkuttelevuus pohjautuu Kreditan aikaisempien asiakkaiden dataan.",
        "paragraph2": "Arviomme perustuu pääosin yrityksen luottoluokitukseen, takaajien tietoihin ja siihen, mitä tietoja olet lisännyt hakemukseen.",
        "paragraph3": "Tuloksesi ei välttämättä ole 100%, jos luottoluokituksesi ei ole vahva tai olet vasta äskettäin perustanut yrityksesi."
      },
      "okButton": "OK",
      "actions": {
        "title": {
          "getAdvice": "Paranna mahdollisuuksiasi neuvonnan avulla.",
          "adviceWithout": "Haluatko lähettää hakemuksen ilman neuvontaa?"
        },
        "button": {
          "adviceCta": "Varaa tapaaminen neuvonantajan kanssa",
          "adviceBack": "Takaisin",
          "adviceWithout": "Lähetä ilman neuvontaa",
          "adviceDigital": "Näytä tarjoukset",
          "adviceDigitalWithoutChanges": "Lähetä ilman parannuksia",
          "improveApplication": "Tee parannuksia hakemukseesi"
        }
      }
    },
    "guarantor": {
      "explanation": {
        "text": {
          "heading": "Tee valinta mahdollisista takaajista",
          "default": "Sitoudut lainan takaajaksi vasta, kun allekirjoitat lainasopimuksen.",
          "soleTrader": "Toiminimiyrittäjänä toimit automaattisesti lainan takaajana.",
          "partnership": "Komandiittiyhtiön yhtiömiehet toimivat automaattisesti lainan takaajina."
        },
        "tooltip": "Takaaja on velvollinen maksamaan, jos yritys ajautuu maksuvaikeuksiin. Takaajan lisääminen on tärkeää mahdollisimman hyvien rahoitustarjousten saamiseksi.",
        "tooltipTrigger": "Mikä on takaaja?",
        "infoTextTitle": "Etkö ole varma, haluatko lisätä takaajan nyt? Se on vapaaehtoista.",
        "infoText": "Voit lisätä takaajan myöhemmin prosessin aikana."
      },
      "me": "Minä",
      "addAnotherGuarantorQuestion": "",
      "addAnotherGuarantorOpen": {
        "empty": "Lisää toinen takaaja",
        "notEmpty": "Lisää takaaja"
      },
      "addContactDetails": "Lisää yhteystiedot",
      "editContactDetails": "Muokkaa yhteystietoja",
      "addAnotherGuarantorClose": "Sulje",
      "personalNumberLabel": "Takaajan henkilötunnus",
      "personalNumberPlaceholder": {
        "SE": "VVVVKKPP-XXXX",
        "FI": "PPKKVV-NNNT"
      },
      "personalNumberInvalid": "Anna kelvollinen henkilötunnus",
      "emailLabel": "Takaajan sähköposti",
      "emailPlaceholder": "Sähköposti",
      "emailInvalid": "Anna kelvollinen sähköposti",
      "phoneLabel": "Takaajan matkapuhelinnumero",
      "phonePlaceholder": "Matkapuhelinnumero",
      "phoneInvalid": "Syötä kelvollinen matkapuhelinnumero",
      "boardMembers": "Hallituksen jäsenet",
      "boardMembersPlaceholder": "Valitse hallituksen jäsen",
      "boardMembersPersonalNumberMsg": "Anna takaajan henkilötunnus"
    },
    "reason": {
      "reasonExplanationTitle": "Kerro tarkemmin liiketoiminnasta ja rahoituksen tarpeesta",
      "otherReasonLabel": "Kuvaus",
      "freetext": "Voi sisältää: Miten käytät rahoitusta ja muuta yrityksestäsi."
    },
    "property": {
      "options": {
        "attachPropertyDocuments": "Liitä kiinteistötodistus tai kiinteistön arviokirjat",
        "property_unit_designation": "Kiinteistötunnus",
        "property_unit_designation_placeholder": "123-456-7890-1234",
        "property_current_mortgage": "Nykyinen kiinnitys kiinteistöön, jos sellainen on",
        "property_current_mortgage_placeholder": "\"200 000 euron kiinnitys\", \"Ei kiinnityksiä\"",
        "property_valuation_label": "Kohteen arvo viimeisimmän arvion mukaan",
        "property_valuation_label_with_purchase_real_estate": "Sovittu kauppahinta",
        "property_valuation_placeholder": {
          "FI": "500 000"
        },
        "property_additional_data_label": "Lisää arviolausunto",
        "property_additional_data_label_with_purchase_real_estate": "Lisää esite tai hinta-arvio",
        "property_additional_data_url_label": "Linkki kohteeseen",
        "property_additional_data_url_placeholder": "https://yritys.fi..."
      }
    },
    "propertyOwner": {
      "yes": "Kyllä",
      "no": "Ei"
    },
    "unpaidInvoices": {
      "about": {
        "newProduct": "Uusi tuote",
        "heading": "Hanki laskurahoitustarjouksia useilta pankeilta ja lainanantajilta ilmaiseksi",
        "paragraph": "Jos yrityksesi myy laskulla, voit myydä laskut ja saada jopa 99 % laskun arvosta alle päivässä. Vastaamalla näihin kysymyksiin näet, mikä laskurahoitus-yhtiö tarjoaa sinulle parhaat ehdot."
      },
      "invoiceValue": {
        "question": "Laskujen kokonaisarvo keskimäärin kuukausittain",
        "placeholder": "50 000"
      },
      "numberOfInvoices": {
        "question": "Laskujen määrä keskimäärin kuukausittain",
        "previewValue": "{{count}} laskua",
        "placeholder": "15"
      },
      "averagePaymentTimeDays": {
        "question": "Keskimääräinen erääntymisaika",
        "choose": "Valitse laskun erääntymisaika"
      },
      "accountsLedger": {
        "question": "Esimerkki laskuista, jotka haluat myydä, tai tilikirjasta",
        "foundWhere": "Mistä löydän reskontran?",
        "preview": "Reskontra (viimeiseltä 12 kuukaudelta)"
      },
      "invoicesDescription": {
        "question": "Pakollinen: Kuvaile kolmea suurinta laskua",
        "placeholder": "Toimiala, laskujen arvo ja palvelun tai tuotteen tyyppi",
        "preview": "Kuvaile kolmea suurinta laskua"
      },
      "dueDateOptions": "{{days}} päivää"
    },
    "selfEstimatedHistoricRevenue": {
      "alertText": "Lisää arvio ajankohdalle",
      "verifyRevenueTitle": "Haluatko vahvistaa <span>liikevaihdon <helper /></span>",
      "automaticFetching": "Automaattinen keräys",
      "helperText": "Voit vahvistaa liikevaihdon kirjanpidon tai tilitietojen kautta. Se ei ole pakollista, mutta auttaa yritystäsi saamaan enemmän ja parempia tarjouksia.",
      "verify": "Vahvista",
      "verificationOptions": {
        "accountingFiles": {
          "title": "Lataa kirjanpito manuaalisesti"
        },
        "bankingData": {
          "title": "Tilitiedot"
        }
      }
    },
    "amount": {
      "valuePlaceholder": "100 000€"
    },
    "repaymentTime": {
      "valuePlaceholder": "12"
    },
    "accountingData": {
      "uploadManually": "Lataa manuaalisesti",
      "delegateChoice": "Pyydä kollegaa tai talousjohtajaa lisäämään",
      "upTo": "asti",
      "accountingManually": {
        "periodText": "Huom. Lisää kirjanpito {{to}} <span>asti <helper /></span>",
        "helper": "Yleensä alustavien lukujen jakaminen riittää. Lainanantaja haluaa ymmärtää, miten yrityksen tuloslaskelma ja tase ovat kehittyneet edellisen tilinpäätöksen jälkeen."
      },
      "uploadManuallyOption": "Muu / Ei tietoa",
      "uploadLater": "Lataa myöhemmin",
      "tabs": {
        "upload": "Lataa",
        "uploadPdf": "Lataa PDF",
        "uploadSie4": "Lataa SIE4",
        "invite": "Kutsu lataamaan",
        "uploadLater": "Lataa myöhemmin",
        "sie4Description": "Vie kirjanpitotiedot SIE4-muodossa kirjanpito-ohjelmastasi.",
        "sie4AcceptedFileTypes": "Lataa SIE4-tiedostot (.se, .si, .sie) tähän",
        "sie4InvalidFileType": "Lataa SIE4-tiedosto (.se, .si tai .sie)."
      }
    },
    "transactionData": {
      "shareVia": "Valinnainen: Jaa tilitietosi viimeisten 3-12 kuukauden ajalta tulojesi varmistamiseksi.",
      "automaticFetching": "Automaattinen keräys",
      "uploadManually": "Lataa tiliote manuaalisesti"
    },
    "fileUpload": {
      "uploadFilesCta": "Lataa tiedostot",
      "acceptedFileTypesMessage": "Useimpia tiedostotyyppejä tuetaan"
    },
    "additionalSecurities": {
      "textareaPlaceholder": "Kirjoita tähän (valinnainen)",
      "attachFiles": "Liitä tiedostoja"
    },
    "leasing": {
      "preview": {
        "financingAmount": "Financing amount",
        "objectType": "Kohteen tyyppi",
        "description": "Kuvaile rahoitettavaa kohdetta/kohteita",
        "amount": "{{amount}} (ilman ALV.)",
        "object": "Kohde"
      }
    },
    "isCollectedByLenderText": "Lisäät nämä tiedot myöhemmin lainanantajan verkkosivuille.",
    "refinancingAmounts": {
      "lenderLabel": "Lainanantaja",
      "lenderPlaceholder": "Pankin nimi",
      "outstandingAmountLabel": "Maksamatta oleva määrä",
      "outstandingAmountPlaceholder": "25 000 {{currency}}",
      "monthlyCostLabel": "Kuukausimaksu (lyhennykset ja kulut)",
      "monthlyCostPlaceholder": "5000 {{currency}}",
      "addFirstOpen": "Lisää nykyinen laina",
      "addMoreOpen": "Lisää toinen laina",
      "addMoreClose": "Sulje",
      "attachmentText": "Liitä mukaan lainasopimus tai viimeisin lasku",
      "close": "Sulje",
      "save": "Tallenna"
    }
  },
  "advice": {
    "digital": {
      "heading": "Tee parannuksia hakemukseesi",
      "subheading": "Tarkastele parannuksia",
      "alertText": "Hakemus lähetetään automaattisesti lainanantajille 10 minuutin kuluttua",
      "submitText": "Lähetä hakemus lainanantajille",
      "likelihood": "Todennäköisyys saada tarjouksia",
      "improvementsHeading": "Anna alla olevat tiedot lisätäksesi todennäköisyyttä saada tarjouksia",
      "possibleImprovements": "Mahdollinen parannus",
      "approvalChanceSummary": "Kasvata hyväksymismahdollisuuttasi {{current}}%:sta {{potential}}%:iin",
      "potentialGain": "+{{gain}}%",
      "currentLikelihood": "Todennäköisyys saada tarjouksia",
      "improvementPotential": "Parannuspotentiaali"
    },
    "revenue": {
      "title": "Lisää viimeisimmät tulotiedot",
      "uploadAccountingData": "Lataa kirjanpito manuaalisesti",
      "uploadBankingData": "Tilitiedot",
      "uploadBankingData2": "Automaattinen tietojen keräys pankkitunnuksilla",
      "noData": "Minulla ei ole jakaa ajankohtaisia myyntilukuja"
    },
    "manual": {
      "heading": "Sinulle tarjotaan neuvontapalveluamme",
      "subheading": "Seuraavat askeleet hakemuksessasi",
      "yourAdvisor": "Neuvonantajasi",
      "advisorContactHint": "Jos sinulla on kysyttävää tai tarvitset apua, olethan yhteydessä neuvonantajaasi.",
      "advisorIntro": "Lisätietojen täyttäminen on vapaaehtoista, mutta niiden avulla rahoitusneuvojamme saa paremman käsityksen yrityksesi toiminnasta ja pystyy rakentamaan puolestasi mahdollisimman vahvan rahoitusesityksen.",
      "whatIsAdvisory": {
        "title": "Mikä on Neuvontapalvelu?",
        "description": "Debt Advisory -palvelumme on suunniteltu yrityksille, jotka hakevat rahoitusta {{minAmount}} ja {{maxAmount}} välillä. Neuvonantajamme vastaa koko rahoitusprosessista alusta loppuun:",
        "list": {
          "item1": "Perusteellinen luottoanalyysi ja rahoitusvaihtoehtojen kartoitus.",
          "item2": "Kattavan rahoitusesityksen laatiminen, jossa yrityksesi liiketoiminta ja kasvupotentiaali esitellään vakuuttavasti rahoittajille.",
          "item3": "Rahoittajien kilpailutus ja koko rahoitusprosessin hallinta.",
          "item4": "Rahoitusehtojen neuvottelu, osallistuminen rahoittajatapaamisiin sekä prosessin läpivienti aina rahoituksen nostoon saakka."
        }
      },
      "whatHappensNext": "Mitä tapahtuu seuraavaksi?",
      "daysEndToEnd": "2–5 päivää alusta loppuun",
      "stepsList": {
        "step1": "Neuvonantajasi ottaa sinuun yhteyttä",
        "step2": "Valmistamme tiiviin rahoitusesityksen",
        "step3": "Jaamme sen sopiville lainanantajille",
        "step4": "Saat tarjouksia ja valitset parhaan"
      },
      "footer": "Koko prosessi kestää vain 2–5 päivää, kunnes saat tarjouksia",
      "submitApplication": {
        "title": "Tarvitsetko rahat nopeammin?",
        "cta": "Lähetä hakemus lainanantajille"
      },
      "bookAdvisory": "Varaa tapaaminen neuvonantajan kanssa"
    },
    "fieldRequests": {
      "heading": "Lisätietoja velkarahoitusneuvontaa varten (vapaaehtoinen)",
      "subheading": "Nämä tiedot auttavat meitä etenemään nopeammin ja luomaan vahvemman rahoitusesityksen sinulle.",
      "timeToFinancing": {
        "timeframeLabel": "Milloin tarvitset rahoituksen?",
        "timeframePlaceholder": "Valitse vaihtoehto",
        "targetDateLabel": "Mikä päivämäärä?",
        "explanationLabel": "Miksi tarvitse rahoituksen tällä aikataululla?",
        "explanationPlaceholder": "Kuvaile aikatauluasi...",
        "helperText": "Tavoitepäivämäärä auttaa meitä priorisoimaan rahoittajia, jotka pystyvät toimimaan aikataulusi mukaan.",
        "choices": {
          "asap": "Mahdollisimman pian",
          "within_1_month": "1 kuukauden sisällä",
          "within_3_months": "3 kuukauden sisällä",
          "no_specific_date": "Ei tiettyä ajankohtaa",
          "specific_date": "Tarkka päivämäärä"
        },
        "submit": "Tallenna"
      },
      "accountingData": {
        "helperText": "Ajantasaiset kirjanpitoajot antaa rahoittajille tarkan kuvan ja säästää turhalta viestinvaihdolta tiimimme kanssa.",
        "helperTextSIE4": "SIE4-tiedostot ovat suositeltavia.",
        "helperTextPdf": "PDF-tiedostot ovat suositeltavia."
      },
      "constructionEstimate": {
        "helperText": "Lataa rakennusbudjetti tai projektin kustannuslaskelma."
      },
      "plPrognosis": {
        "helperText": "Tulosennuste auttaa rahoittajia ymmärtämään yrityksesi tulevaisuudennäkymiä ja suunnitelmia. Voit luoda uuden ennusteen tekoälyn avulla tai ladata palveluun valmiin tiedoston.",
        "tableTitle": "Tulosennuste",
        "acquirerTab": "Hankkiva yritys",
        "targetTab": "Kohdeyhtiö",
        "draftTab": "Laadi tulosennuste",
        "uploadTab": "Lataa tiedosto",
        "fileUploadLabel": "Lataa tulosennusteesi",
        "aiAssist": {
          "open": "Tekoälyavustin",
          "preparing": "Valmistellaan tekoälyavustinta",
          "startPromptLabel": "Aloita tulosennusteen tekeminen",
          "startPromptText": "Auta minua rakentamaan tulosennusteeni",
          "noAssistMode": "Aloita klikkaamalla tekoälyavustin-painiketta."
        },
        "standard": {
          "revenue_excl_vat": "Liikevaihto",
          "personnel_costs": "Henkilöstökulut",
          "other_costs": "Muut kulut",
          "ebitda": "EBITDA"
        },
        "real_estate": {
          "rental_income": "Vuokratuotot",
          "operating_costs": "Käyttökustannukset",
          "property_tax": "Kiinteistövero",
          "net_operating_income": "Nettotuotto"
        },
        "yearSuffix": {
          "actual": "toteutunut",
          "forecast": "ennuste"
        },
        "notes": {
          "label": "Lisätietoja rahoitusneuvojalle",
          "placeholder": "Olennaisia lisätietoja hakemusta varten rahoitusneuvojalle..."
        }
      }
    }
  },
  "dash": {
    "heading": "Etsimme parhaillaan tarjouksia hakemukseesi",
    "headingBidsReceived": "Tarjouksesi ovat matkalla",
    "headingNoBidsReceived": "Et ole toistaiseksi saanut yhtään tarjousta",
    "headingBidSelected": "Saadut tarjoukset",
    "headingPaidOutOffers": "Maksetut tarjoukset",
    "applicationHasBeenSent": "Hakemuksesi on lähetetty rahoittajille.",
    "biddingOpen": "Tarjousaika on vielä auki ({{formattedLenderTimeLeft}} jäljellä)",
    "biddingClosed": "Tarjousaika on päättynyt",
    "offersValidFor": "Tarjoukset ovat voimassa {{daysLeft}} päivää",
    "offersValidForLessThanDay": "Tarjoukset ovat voimassa {{hoursLeft}} tuntia",
    "biddingOpensSoon": "Hakemus avataan pian lainanantajille",
    "applicationNotSubmitted": "Hakemusta ei ole vielä lähetetty",
    "rejectedMessage": "Ota yhteyttä asiakaspalveluun, jos tarvitset apua hakemuksesi kanssa.",
    "noBidsMessage": "Et ole saanut tarjouksia hakemukseesi.",
    "noBidsImproveApplicationRecommend": "Suosittelemme tekemään uuden hakemuksen 3 kuukauden kuluttua. \n Ota yhteyttä asiakaspalveluun, jos tarvitset apua hakemuksesi kanssa.",
    "noBidsStartNewApplication": "Aloita uusi hakemus",
    "biddingExpiredNoBids": {
      "title": "Tarjouksia ei ole toistaiseksi saatu",
      "description": "Ota yhteyttä asiakaspalveluun, jos tarvitset apua hakemuksesi kanssa."
    },
    "bidsReceived": {
      "title": "Olet saanut {{bidsCount}} rahoitustarjousta.",
      "subtitle": "Hakemuksesi virallinen tarjousaika on päättynyt."
    },
    "noBindingOffersBanner": "Tarjouksen valitseminen ei sido teitä mihinkään. Voitte muuttaa valintaanne milloin tahansa.",
    "selectedBidLabel": "Valittu tarjous",
    "recommendedBidLabel": "Suositeltu",
    "paidOutBidLabel": "Maksettu tarjous",
    "goodAlternativeBidLabel": "Hyvä vaihtoehto",
    "promotionTitle": "Kampanjatarjous",
    "promotions": {
      "amortisation_free_one": "Ensimmäinen kuukausi ilman lyhennyksiä",
      "amortisation_free_other": "Ensimmäiset {{count}} kuukautta ilman lyhennyksiä",
      "interest_free_one": "Ensimmäinen kuukausi ilman korkoa",
      "interest_free_other": "Ensimmäiset {{count}} kuukautta ilman korkoa"
    },
    "creditTerms": "Luottoehdot",
    "showDetails": "Yksityiskohdat",
    "hideDetails": "Piilota",
    "sortOffers": "Lajittele tarjoukset",
    "bestOffer": "Paras tarjous",
    "sortKeys": {
      "bestOffer": {
        "desc": "Paras tarjous"
      },
      "amount": {
        "asc": "Pienin summa",
        "desc": "Suurin summa"
      },
      "paybackTimeMonths": {
        "asc": "Lyhin takaisinmaksuaika",
        "desc": "Pisin takaisinmaksuaika"
      },
      "averageMonthlyPayment": {
        "asc": "Pienin kuukausierä",
        "desc": "Suurin kuukausierä"
      },
      "totalLoanAmount": {
        "asc": "Pienin kokonaissumma",
        "desc": "Suurin kokonaissumma"
      },
      "commissionPercent": {
        "asc": "Pienin provisio",
        "desc": "Suurin provisio"
      },
      "withRegress": {
        "asc": "Ilman regressia ensin",
        "desc": "Regressilla ensin"
      },
      "limit": {
        "asc": "Pienin luottoraja",
        "desc": "Suurin luottoraja"
      },
      "firstMonthInterestRate": {
        "asc": "Pienin ensimmäisenä kuukautena korko",
        "desc": "Suurin ensimmäisenä kuukautena korko"
      },
      "comparableMonthlyInterestRate": {
        "asc": "Pienin kuukausikorko",
        "desc": "Suurin kuukausikorko"
      },
      "comparableYearlyInterestRate": {
        "asc": "Pienin vuosikorko",
        "desc": "Suurin vuosikorko"
      }
    },
    "changeInformationForApplication": {
      "title": "Haluatko muuttaa hakemuksessa antamiasi tietoja?",
      "back": "Takaisin"
    },
    "closeApplicationAsCustomer": {
      "title": "Haluatko sulkea hakemuksesi?",
      "description": "Jos suljet hakemuksesi nyt, nykyiset tarjouksesi eivät ole enää käytettävissäsi, ja sinun on aloitettava uusi hakemus, jos haluat saada tarjouksia uudelleen.",
      "buttonText": "Sulje hakemus",
      "confirmation": {
        "title": "Miksi haluat sulkea hakemuksen?",
        "selectTitle": "Valitse syy",
        "descriptionPlaceholder": "Kuvaile, miksi haluat sulkea hakemuksen",
        "confirm": "Sulje hakemus"
      }
    },
    "biddingOpenLabel": "Tarjousaika jäljellä",
    "countdown": {
      "day": "päivä",
      "days": "päivää",
      "hour": "tunti",
      "hours": "tuntia",
      "minute": "minuutti",
      "minutes": "minuuttia"
    },
    "offersWillAppearHere": "Mahdolliset tarjoukset näkyvät täällä.",
    "sidebar": {
      "applicationInformation": "Hakemustiedot",
      "requestedAmount": "Pyydetty määrä",
      "financingAmount": "Rahoitusmäärä",
      "objectType": "Kohteen tyyppi",
      "purpose": "Tarkoitus",
      "repaymentTime": "Takaisinmaksuaika",
      "guarantors": "Takaajat",
      "property": "Kiinteistö",
      "leasing": "Leasing",
      "unpaid_invoices": "Laskutusrahoitus",
      "editApplication": "Muokkaa hakemustasi"
    },
    "chooseBidButton": "Valitse",
    "chooseBidButtonAfterSelected": "Viimeistele",
    "chooseBidConfirmation": {
      "title": "Haluatko valita tämän tarjouksen?",
      "additions": {
        "description1": "Saadaksesi sopimuksen, sinun on lisättävä seuraavat tiedot."
      },
      "description1": "Klikkaamalla \"Valitse tarjous\" lainanantaja saa ilmoituksen, että olet kiinnostunut tarjouksesta.",
      "description2": "Tässä vaiheessa et sitoudu vielä mihinkään.",
      "cancel": "Peruuta",
      "continue": "Valitse tarjous",
      "modal": {
        "title": "Haluatko edetä tarjouksen kanssa?",
        "proceedingIsNonBinding": "Tarjouksen valitseminen ei sido teitä mihinkään.",
        "nextStep": "Seuraava askel:",
        "lenderWillContactYou": "Luotonantaja ottaa sinuun yhteyttä",
        "provideFinalInformation": "Toimita lopulliset tiedot suoraan luotonantajalle",
        "provideMissingInformation": "Toimita puuttuvat tiedot lopullista luottopäätöstä varten",
        "proceed": "Valitse",
        "contactDetailsSharedWithLender": "Yhteystietosi jaetaan {{lender}} kanssa:",
        "multipleGuarantorsRequired": "Huom: Vaatimus {{guarantorsNumber}} takaajasta, joilla on vakaa taloudellinen tilanne ja tulot"
      }
    },
    "comboOffers": {
      "heading": "Yhdistelmätarjoukset",
      "description": "Yhdistelmätarjoukset: Räätälöity rahoitusratkaisu, jossa yhdistetään kaksi tai useampia rahoitusvaihtoehtoja (esim. yrityslaina ja luottolimiitti) erilaisiin rahoitustarpeisiin soveltuvaksi.",
      "totalAmount": "Kokonaissumma",
      "upToAmount": "Jopa {{amount}} asti"
    },
    "loanBids": {
      "heading": "Yrityslaina",
      "description": "Yrityslainan avulla yrityksesi saa käyttöönsä tietyn rahamäärän, jonka maksat takaisin ajan mittaan korkoineen. Sitä käytetään yleensä kasvun rahoittamiseen tai päivittäisen toiminnan tukemiseen.",
      "paybackTimeMonthFormat": "kuukausi",
      "paybackTimeMonthsFormat": "kuukautta",
      "columns": {
        "lender": "Lainanantaja",
        "lenderDescription": "Tästä näet, mikä lainanantaja on antanut lainatarjouksen",
        "amount": "Summa",
        "approvedAmount": "Summa",
        "approvedAmountDescription": "Tämä on summa, jonka lainanantaja tarjoaa sinulle lainaksi. On tavallista, että tarjottu summa eroaa pyydetystä. Syynä on se, että lainanantaja antaa parhaan tarjouksen saamiensa tietojen perusteella, vaikka tarjottu summa ei olisikaan sama kuin pyydetty.",
        "repaymentTime": "Takaisinmaksuaika",
        "repaymentTimeDescription": "Takaisinmaksuaika on aika, jonka kuluessa laina tulee maksaa takaisin.",
        "averageMonthlyPayment": "Kuukausimaksu",
        "monthlyCost": "Kuukausimaksu",
        "monthlyCostDescription": "Kuukausimaksu näyttää keskimääräisen summan, joka maksetaan lainanantajalle kuukaudessa takaisinmaksuajan aikana. Kukin kuukausierä voi vaihdella lyhennystavasta riippuen, mutta keskimääräinen summa näkyy tässä sarakkeessa.",
        "totalCost": "Lainan kokonaiskustannukset",
        "totalCostDescription": "Kokonaiskustannukset, mukaan lukien kaikki kulut ja maksut, mutta ei lainattua määrää.",
        "importantInfo": "Edut"
      }
    },
    "factoringBids": {
      "heading": "Laskurahoitus",
      "description": "Laskurahoitus / factoring antaa yrityksellesi mahdollisuuden saada rahoitusta heti myymällä tai panttaamalla laskusi rahoitusyhtiölle sen sijaan, että odottaisit asiakkaidesi maksusuorituksia.",
      "withRegressYes": "Kyllä",
      "withRegressNo": "Ei",
      "paymentTermsDays": "päivää",
      "columns": {
        "factoringCompany": "Laskurahoitusyhtiö",
        "factoringCompanyDescription": "Tässä ovat laskurahoitusyhtiöt, jotka ovat jättäneet laskurahoitustarjoukset",
        "approvedAmount": "Tarjottu summa",
        "approvedAmountDescription": "Tarjottu summa on summa, jota sinulle tarjotaan lainaksi laskurahoitusyhtiöltä. Mikäli laskurahoitusyhtiö ei halua rahoittaa koko laskun summaa, tarjottu summa voi olla pienempi kuin laskun arvo, jonka haluat myydä. Yksi syy voi olla se, että laskut eivät ole linjassa laskurahoitusyhtiön asettamien vaatimusten kanssa - esimerkiksi jos laskun vastaanottajan luottoluokitus on liian alhainen tai laskuilla on liian pitkä takaisinmaksuaika. Tarjoukset eivät ole sitovia ja voit valita, haluatko jatkaa vai et.",
        "commissionTime": "Komissio laskua kohden",
        "commissionTimeDescription": "Hinta per rahoitettu lasku, jonka laskurahoitusyhtiö ottaa. Tämä sisältää rahoituksen, mutta myös palvelut, joita saat käyttöösi (kuten muistutukset, perinnän, luottotarkastukset jne.).",
        "paidOutAmount": "Maksettava summa",
        "paidOutAmountDescription": "Maksettava summa määrittää summan, joka maksetaan ensimmäisessä maksussa laskurahoitusyhtiöltä sinulle. Maksettava summa sisältää kaikki korot ja maksut. Palvelusta maksettavien hyvitysten päälle lisätään arvolisävero (alv) eli ostohinnan ja laskujen nimellisarvon erotus sekä kaikki veloitettavat maksut.",
        "regressCost": "Takautumisoikeus",
        "regressCostDescription": "Määrittää, onko laskurahoitusyhtiöllä oikeutta vaatia sinulta maksu takaisin, jos laskun saaja ei maksa. Takautumisoikeus on yleensä aikarajoitettu, mikä tarkoittaa, että asiakkaaltasi maksua havitteleva laskurahoitusyhtiö vaatii sinua maksamaan tietyn ajan jälkeen. Tämä pätee vain, jos laskurahoitusyhtiö tarjoaa laskun ostoja takautumisoikeudella.",
        "importantInfo": "Edut"
      }
    },
    "realEstateBids": {
      "heading": "Kiinteistölaina",
      "description": "Kiinteistölainan avulla yrityksesi saa rahoitusta, jota voidaan käyttää kiinteistön ostamiseen, jälleenrahoittamiseen tai kehittämiseen.",
      "paybackTimeMonthFormat": "kuukausi",
      "paybackTimeMonthsFormat": "kuukautta",
      "columns": {
        "lender": "Lainanantaja",
        "lenderDescription": "Tästä näet, mikä lainanantaja on antanut lainatarjouksen",
        "amount": "Summa",
        "approvedAmount": "Summa",
        "approvedAmountDescription": "Tämä on summa, jonka lainanantaja tarjoaa sinulle lainaksi. On tavallista, että tarjottu summa eroaa pyydetystä. Syynä on se, että lainanantaja antaa parhaan tarjouksen saamiensa tietojen perusteella, vaikka tarjottu summa ei olisikaan sama kuin pyydetty.",
        "repaymentTime": "Takaisinmaksuaika",
        "repaymentTimeDescription": "Takaisinmaksuaika on aika, jonka kuluessa laina tulee maksaa takaisin.",
        "averageMonthlyPayment": "Kuukausimaksu",
        "monthlyCost": "Kuukausimaksu",
        "monthlyCostDescription": "Kuukausimaksu näyttää keskimääräisen summan, joka maksetaan lainanantajalle kuukaudessa takaisinmaksuajan aikana. Kukin kuukausierä voi vaihdella lyhennystavasta riippuen, mutta keskimääräinen summa näkyy tässä sarakkeessa.",
        "totalCost": "Lainan kokonaiskustannukset",
        "totalCostDescription": "Lainan kokonaiskustannukset, mukaan lukien kaikki kulut ja maksut, mutta ei lainattua määrää.",
        "importantInfo": "Edut"
      }
    },
    "leasingBids": {
      "heading": "Leasing",
      "description": "Leasing antaa yrityksellesi mahdollisuuden hankkia laitteita tai muuta kalustoa käyttöön maksamalla niistä kuukausittaista vuokraa sopimuskauden ajan, usein mahdollisuudella lunastaa kohde omaksi sopimuskauden päättyessä.",
      "columns": {
        "lender": {
          "title": "Leasing-yritys",
          "description": "Tästä näet mitkä leasing-yritykset ovat tehneet tarjouksen"
        },
        "amount": {
          "title": "Summa",
          "description": "Tämä on määrä, jonka leasing-yritys on tarjonnut. Summa vastaa usein omaisuuden ostohintaa (Ilman ALV:ia), jonka haluat vuokrata. Tarjous ei ole sitova, ja sinä valitset, haluatko valita sen vai et"
        },
        "repaymentTime": {
          "title": "Leasing-aika",
          "description": "Leasing-aika on aika (kuukausien lukumäärä), jonka ajan leasing-sopimus on pätevä. Vuokrausajan päättyessä yrityksellä on vaihtoehtona jatkaa kohteen vuokrausta, ostaa se loppuarvolla tai palauttaa se kohde vuokrausyritykselle."
        },
        "monthlyPayment": {
          "title": "Kuukausimaksu",
          "description": "Kuukausimaksu näyttää keskimääräisen summan, joka maksetaan leasing-yritykselle kuukaudessa leasing-ajan aikana. Kuukausimaksut voivat vaihdella, riippuen loppuarvon suuruudesta tai jos suoritetaan ennakkomaksu. Kuukausimaksujen summa on kuitenkin sama koko leasing-ajan"
        },
        "monthlyCost": {
          "title": "Kuukausimaksu",
          "description": "Kuukausimaksu näyttää keskimääräisen summan, joka maksetaan leasing-yritykselle kuukaudessa leasing-ajan aikana. Kuukausimaksut voivat vaihdella, riippuen loppuarvon suuruudesta tai jos suoritetaan ennakkomaksu. Kuukausimaksujen summa on kuitenkin sama koko leasing-ajan"
        },
        "totalCost": {
          "title": "Leasingin kokonaiskustannukset",
          "description": "Kokonaiskustannukset sisältäen kaikki kustannukset ja maksut, mutta ei ennakomaksuja tai loppuarvoa, joka yrityksesi saattaa joutua maksamaan leasing-ajan lopussa"
        },
        "importantInfo": {
          "title": "Edut"
        }
      }
    },
    "revolvingCreditBids": {
      "heading": "Yrityslimiitti",
      "description": "Yrityslimiitti antaa yrityksellesi käyttöön joustavan luottorajan, josta voit nostaa varoja tarpeen mukaan. Korkoa maksetaan yleensä vain käytössä olevasta luoton määrästä.",
      "columns": {
        "lender": {
          "title": "Lainanantaja",
          "description": "Tästä näät, mitkä lainanantajat ovat antaneet tarjouksen"
        },
        "limit": {
          "title": "Limiitti",
          "description": "Tämä on limiitti, jonka lainanantaja tarjoaa lainaksi. On yleistä, että lainanantajan tarjoama summa eroaa pyydetystä. Syynä tähän on, että lainanantaja antaa parhaan mahdollisen tarjouksen saamiensa tietoken perusteella, vaikka tarjottu summa ei ole sama kuin pyydetty."
        },
        "averageMonthlyPayment": {
          "title": "Kuukausimaksu",
          "description": "Kuukausimaksu näyttää keskimääräisen summan, joka maksetaan lainanantajlle kuukaudessa. Yrityslimiittitarjouksissa oletamme, että limiitistä hyödynnetään keskimäärin noin 50%. Kuukausimaksujen koko vaihtelee joka kuukausi."
        },
        "amortisationPerMonth": {
          "title": "Kuukausittainen lyhennys",
          "description": "Yrityslimiitissätarjouksessa voi olla kuukausittainen lyhennysvaatimus. Alkumaksujen jälkeen voit kuitenkin nostaa lisävaroja luottorajan määrään asti."
        },
        "importantInfo": {
          "title": "Edut"
        }
      }
    },
    "purchaseFinancingBids": {
      "heading": "Ostolaskurahoitus",
      "description": "Ostolaskurahoitus on lyhytaikainen rahoitusratkaisu, jonka avulla yrityksesi voi hankkia tavaroita tai materiaaleja ilman, että kassavarat sitoutuvat. Rahoitusyhtiö maksaa toimittajan laskun etukäteen, ja yrityksesi maksaa summan takaisin sovituissa erissä.",
      "columns": {
        "lender": {
          "title": "Lainanantaja",
          "description": "Tästä näät, mitkä lainanantajat ovat antaneet tarjouksen"
        },
        "amount": {
          "title": "Summa",
          "description": "Tämä on summa, jonka lainanantaja tarjoaa rahoitettavaksi."
        },
        "averageMonthlyPayment": {
          "title": "Kuukausimaksu",
          "description": "Kuukausimaksu näyttää keskimääräisen summan, joka maksetaan lainanantajalle kuukaudessa."
        },
        "importantInfo": {
          "title": "Edut"
        }
      }
    },
    "commonBidsColumns": {
      "comparableYearlyInterestRate": {
        "title": "Todellinen vuosikorko",
        "description": "Todellinen vuosikorko näyttää lainan keskimääräisen kustannuksen (prosentteina) ja sisältää kaikki korot ja kulut. Tämä korko voi olla eri kuin lainanantajan ilmoittama, sillä he laskevat sen joskus eri tavalla."
      },
      "comparableMonthlyInterestRate": {
        "title": "Todellinen kuukausikorko",
        "description": "Todellinen kuukausikorko näyttää lainan keskimääräisen kustannuksen (prosentteina) ja sisältää kaikki korot ja kulut. Tämä korko voi olla eri kuin lainanantajan ilmoittama, sillä he laskevat sen joskus eri tavalla."
      },
      "firstMonthInterestRate": {
        "title": "Ensimmäisen kuun korko",
        "description": "Ensimmäisen kuun korko näyttää lainan kustannuksen (prosentteina)sillä oletuksella, että laina-aika olisi vain yksi kuukausi. Tämä ei ota huomioon mahdollisia lainan lisäkustannuksia. Lisäksi korko voi olla eri lainan eri ajanjaksoilla."
      },
      "details": "Yksityiskohdat"
    },
    "bidsRateToaster": {
      "text": "Tarjousten lajitteluperuste",
      "comparableYearlyInterestRate": {
        "selected": "Todellinen vuosikorko",
        "showText": "Näytä todellinen vuosikorko"
      },
      "comparableMonthlyInterestRate": {
        "selected": "Todellinen kuukausikorko",
        "showText": "Näytä todellinen kuukausikorko"
      },
      "firstMonthInterestRate": {
        "selected": "Ensimmäisen kuun korko",
        "showText": "Näytä ensimmäisen kuun korko"
      }
    },
    "chooseOtherBid": {
      "text": "Jos haluat vaihtaa tarjousta tai sinulla on kysyttävää, ota yhteyttä asiakaspalveluun.",
      "cancelButton": "Peruuta",
      "confirmButton": "Ota yhteyttä asiakaspalveluun"
    },
    "createdState": {
      "heading": "Hakemustasi ei ole vielä lähetetty"
    },
    "rejectedState": {
      "heading": "Hakemustasi ei ole lähetetty"
    },
    "bidsRejected": {
      "heading": "Huomasimme, että olet hylännyt uudet tarjoukset tälle hakemukselle.",
      "paragraphWithLinktoSupport": "Jos tämä ei vaikuta oikealta, <1>ota yhteyttä asiakaspalveluun</1>"
    },
    "importantInfo": {
      "euLoanBidDetailsHeading": "Yrityslaina EU-tuella",
      "euLoanBidDetailsText": "Tällä lainatarjouksella on EU:n tuki, joten ehdot muuttuvat edullisemmiksi. Lainalla on alhaisempi korko ja rajoitettu takaussitoumus, joka on vain 20 % lainan määrästä. Syynä on, että laina on katettu Euroopan unionin Employment and Social Innovation Programme (EaSI) rahoittamalla takauksella."
    },
    "messages": {
      "applicationNotSubmitted": {
        "title": "Hakemustasi ei lähetetty automaattisesti.",
        "subtitle": "Asiakaspalvelumme ottaa sinuun yhteyttä",
        "reason": "Mikä voisi olla syynä?",
        "description": "Tämä voi johtua siitä, että sinulla on aikaisempi hakemus, jota ei ole vielä viimeistelty, tai siitä, että sinulta puuttuu yrityksen allekirjoitusoikeudet. Asiakaspalvelumme on sinuun yhteydessä yhden arkipäivän kuluessa.",
        "duplicate": {
          "title": "Edellistä hakemustasi ei ole vielä suljettu.",
          "subtitle": "Valitse alta, miten haluat edetä.",
          "readMoreText": "Lue lisää",
          "readMoreModalText": "Aiemman hakemuksesi lainatarjoukset ovat voimassa vähintään 30 päivää. Suosittelemme jatkamaan aiempaa hakemusta, jos sinulla on vielä voimassa olevia tarjouksia.",
          "continueWithApplication": {
            "title": "Jatka edellistä hakemusta",
            "description": "Hakemus on tehty {{creationDate}} ja sillä on {{noActiveOffers}} aktiivista tarjoiusta",
            "actionText": "Jatka edellistä hakemusta"
          },
          "submitNewApplication": {
            "title": "Lähetä uusi hakemus ja sulje edellinen hakemus",
            "description": "Kun lähetät hakemuksen, edellinen hakemus sulkeutuu. Sinulla ei ole pääsyä edelliseen hakemuksen tarjouksiin tai muihin tietoihin.",
            "actionText": "Lähetä uusi hakemus"
          }
        },
        "noSigningRights": {
          "title": "Emme voineet automaattisesti vahvistaa yhteyttäsi tähän yritykseen julkisista rekistereistä.",
          "subtitle": "Kuvaile yhteytesi yritykseen alla.",
          "submitExplanationButton": "Lähetä",
          "explanationSubmitted": "Selvityksesi on lähetetty. Asiakaspalvelumme ottaa sinuun yhteyttä."
        }
      },
      "rejectedByKrea": {
        "description": "Tämä voi johtua siitä, että yritystäsi ei ole vielä täysin rekisteröity. Sinulla saattaa myös olla aikaisempi hakemus, joka on edelleen avoinna. Asiakaspalvelumme on sinuun yhteydessä yhden arkipäivän aikana."
      },
      "applicationAdvice": {
        "title": "Olemme huomanneet, että samankaltaiset yritykset saavat parempia tarjouksia neuvonantajiemme avulla.",
        "subtitle": "Jos haluat saada neuvontaa, yksi neuvonantajistamme ottaa sinuun yhteyttä yhden arkipäivän sisällä."
      },
      "applicationSimpleManualAdvice": {
        "title": "Haluatko jatkaa keskustelematta ensin neuvonantajasi kanssa?",
        "subtitle": "Voitte lähettää hakemuksen ilman puhelinkeskustelua, mutta se saattaa johtaa huonompiin tarjouksiin."
      },
      "applicationAdviceWaiting": {
        "title": "Neuvonantaja ottaa sinuun yhteyttä yhden arkipäivän sisällä."
      },
      "applicationDigitalAdvice": {
        "title": "Tunnistimme mahdollisia kehityskohteita hakemuksessasi.",
        "subtitle": "Paranna hakemustasi seuraamalla suosituksiamme.",
        "subtitleAdvicePage": "Nämä parannukset voivat johtaa parempiin tarjouksiin."
      }
    }
  },
  "bidType": {
    "COMPANY_LOAN": "Yrityslaina",
    "FACTORING": "Laskurahoitus",
    "LEASING": "Leasing",
    "REAL_ESTATE": "Kiinteistölaina",
    "REVOLVING_CREDIT": "Yrityslimiitti",
    "PURCHASE_FINANCING": "Ostolaskurahoitus"
  },
  "bidDetails": {
    "show": "Näytä valitun tarjouksen tiedot",
    "repaymentTime": "Takaisinmaksuaika",
    "contractInterestMonthly": "Sopimuksessa ilmoitettu kuukausikorko tai maksu",
    "contractInterestYearly": "Sopimuksessa ilmoitettu vuosikorko",
    "amortisation": "Lyhennystapa",
    "totalCost": "Lainan kokonaiskustannukset (korkokulut ja muut maksut)",
    "averageMonthlyPayment": "Keskimääräinen kuukausimaksu (lyhennys ja korkokulut)",
    "averageMonthlyCost": "Keskimääräinen kuukausimaksu (korko ja muut kulut)",
    "firstMonthCost": "Ensimmäisen kuukauden kulut (korot ja palkkiot)",
    "firstMonthRate": "Ensimmäisen kuun korko",
    "monthlyRate": "Kuukausikorko",
    "yearlyRate": "Vuosikorko",
    "earlyRepaymentFee": "Ennenaikaisen takaisinmaksun kustannukset",
    "repayableWithoutFee": "Ei kustannuksia",
    "setupFee": "Perustamismaksu",
    "postalFee": "Postimaksu (kuukaudessa)",
    "directDebitFee": "Suoraveloitusmaksu (kuukaudessa)",
    "totalCostExplainer": "Kaikki maksut sisältyvät lainan kokonaikustannuksiin",
    "oneTimeFee": "kertamaksu",
    "daily": "päivässä",
    "weekly": "viikossa",
    "monthly": "kuukaudessa",
    "quarterly": "vuosineljänneksessä",
    "yearly": "vuodessa",
    "benefits": "Edut",
    "importantCollateral": "Vakuus",
    "additionalInformation": "Tietoja lopullista luottopäätöstä varten:",
    "moreAbout": "Lisää tietoa: ",
    "registeredByFI": "Suomen finanssivalvonnan hyväksymä",
    "paidOutShow": "Katso tarjouksen yksityiskohdat",
    "paidOutStartNew": "Hae rahoitusta uudestaan",
    "collectedByLenderFieldRequestInfo": "Haetaan automaattisesti pankkitunnuksilla - vie vain 2-3 minuuttia",
    "lenderComment": "Lainanantajan kommentti: ",
    "alreadySubmitted": "Lähetetty jo aikaisemmin",
    "submitInNextStep": "Lähetä seuraavassa vaiheessa",
    "submitToLenderSite": "Lähetä lainanantajan sivustolle",
    "keyCalculations": "Avainlaskelmat tarjoukseesi",
    "lender": "Lainanantaja",
    "principalRepayment": "Pääoman lyhennys",
    "interestPayment": "Korkomaksu",
    "monthlyPayment": "Keskimääräinen kuukausimaksu",
    "firstMonthAmortisation": "Ensimmäisen kuukauden lyhennys",
    "firstMonthPayment": "Ensimmäisen kuukauden maksu",
    "principalRepaymentPerMonth": "Pääoman lyhennys (kuukaudessa)",
    "interestPaymentPerMonth": "Korkomaksu (kuukaudessa)",
    "monthlyPaymentPerMonth": "Kuukausimaksu (kuukaudessa)",
    "costPerMonth": "Kulut (kuukaudessa)",
    "amount": "Summa",
    "fixedMonthlyFee": "Kiinteä kuukausimaksu"
  },
  "realEstateBidDetails": {
    "repaymentTimeMonths": "Laina-aika"
  },
  "factoringBidDetails": {
    "show": "Näytä valitun tarjouksen tiedot",
    "purchasedAmountPercent": "Rahoitusosuus (%)",
    "purchaseLimit": "Laskun ostoraja",
    "limitFeePerYearPercent": "Limittimaksu (vuodessa)",
    "setupFee": "Järjestelypalkkio",
    "handlingFeePerInvoice": "Käsittelymaksu per lasku (ilman postikuluja)",
    "monthlyFee": "Ylimääräinen kuukausimaksu",
    "totalMonthlyCost": "Kuukausikustannus",
    "regressNumDaysAfterDueDate": "Takautumispäivien lukumäärä",
    "regressDaysFormat": "päivät",
    "totalCostExplainer": "Kaikki maksut sisältyvät lainan kokonaiskustannuksiin",
    "monthly": "kuukaudessa"
  },
  "leasingBidDetails": {
    "downPayment": "Ennakkomaksu",
    "terminalValue": {
      "title": "Jäännösarvo",
      "description": "Loppuarvo koskee vain rahoitusleasingsopimuksia (eli ei vuokraa). Loppuarvo näyttää kohteen arvioitua arvoa leasing-ajan lopussa. Kun sopimus päättyy, voit ostaa leasing-kohteen leasingyhtiöltä maksamalla loppuarvon."
    },
    "setupFee": "Järjestelypalkkio",
    "totalCost": "Leasingin kokonaiskustannukset ",
    "totalCostExplainer": "Kaikki yläpuolella listatut kustannukset sisältyvät kokonaiskustannuksiin",
    "typeOfContract": {
      "title": "Sopimuksen tyyppi",
      "type": {
        "leasing": {
          "title": "Leasing",
          "description": "Leasing sopii yrityksille, jotka haluavat investoida uusiin tai käytettyihin työkaluihin, koneisiin tai laitteisiin ilman, että heidän tarvitsee ostaa niitä tai lainata rahaa niitä varten. Vuokrasopimuksen päätyttyä voit joko jatkaa sopimusta, ostaa kohteen loppuarvolla tai palauttaa kohteen vuokrausyritykselle."
        },
        "rent": {
          "title": "Vuokra",
          "description": "Joskus on sopivampaa vuokrata kohde. Erityisesti jos haluat vaihtaa laitteita kesken leasing-ajan. Leasing-ajan lopussa voit pidentää vuokrasopumusta tai palauttaa vuokratun kohteen leasing-yhtiölle"
        }
      }
    },
    "postalFee": "Postimaksu (ei sisälly kuukausimaksuun)",
    "insuranceCostPerMonth": "Vakuutusmaksu per kuukausi (ei sisälly kuukausikustannuksiin)"
  },
  "revolvingCreditBidDetails": {
    "amount": "Luottoraja",
    "monthlyInterestRate": "Korko (per kuukausi)",
    "monthlyAmortisation": "Lyhennys per kuukausi",
    "setupFee": "Järjestelypalkkio",
    "postalFee": "Postimaksu",
    "withdrawalFee": {
      "title": "Nostopalkkio",
      "description": "Nostopalkkio veloitetaan joka kerta kun haluat nostaa lisävaroja sinulle myönnetystä limiitistä"
    },
    "limitFeePerYear": "Limiittimaksu vuodessa"
  },
  "revolvingCreditBidDetais": {
    "monthlyInterestRate": "Sopimuksessa ilmoitettu kuukausikorko tai maksu ",
    "lenderMonthlyInterest": "Kuukausikorko",
    "averageMonthlyPayment": {
      "title": "Kuukausimaksu",
      "description": "Perustuu oletukseen, että limiitistä hyödynnetään keskimäärin 50%. Kuukausittaisten maksujen summa vaihtelee kuukausittain."
    },
    "averageMonthlyCost": {
      "title": "Keskimääräinen kuukausimaksu (korko ja muut kulut)",
      "description": "Perustuu oletukseen, että limiitistä hyödynnetään keskimäärin 50%."
    },
    "setupFee": "Järjestelypalkkio",
    "postalFee": "Postimaksu",
    "withdrawalFee": {
      "title": "Nostopalkkio",
      "description": "Nostopalkkio veloitetaan joka kerta kun haluat nostaa lisävaroja sinulle myönnetystä limiitistä"
    },
    "limitFeePerYear": "Limiittimaksu vuodessa"
  },
  "recommendedSelect": {
    "toast": {
      "heading": "Olet saanut hyvän alustavan tarjouksen {{lenderCompanyName}}:lta",
      "subheading": "Tämä tarjous näyttää sopivan tilanteeseesi parhaiten. Viimeistele hakuprosessi saadaksesi varat maksuun."
    },
    "proceedWithAnotherOfferToast": {
      "heading": "Haluatko jatkaa toisella tarjouksella?",
      "subheading": "Tee valintasi alla."
    }
  },
  "postSelect": {
    "heading": {
      "default": "Lisää tietoja ",
      "withLenderSigningUrl": "Viimeistele hakemus {{lenderCompanyName}} kanssa",
      "withoutLenderSigningUrl": "{{lenderCompanyName}} ottaa sinuun yhteyttä"
    },
    "toast": {
      "requiredInformation": "Täytä vaaditut tiedot saadaksesi rahoituksen",
      "withLinkToLender": {
        "title": "Lainanantaja pyytää sinua viimeistelemään hakemuksesi omassa palvelussaan",
        "buttonText": "Jatka lainanantajan verkkosivustolla"
      },
      "withoutLinkToLender": {
        "title": "Olet antanut kaikki tarvittavat tiedot.",
        "subtitle": "Lainanantaja tarkistaa vielä hakemuksesi ja ottaa sinuun pian yhteyttä"
      }
    },
    "productDetails": {
      "title": "Tiedot",
      "companyLoan": "Lainatiedot",
      "factoring": "Laskun ostotiedot",
      "leasing": "Leasingtiedot",
      "realEstate": "Kiinteistötiedot",
      "revolvingCredit": "Yrityslimiitin tiedot"
    },
    "lenderComment": "Kommentti lainanantajalta",
    "isCollectedByLender": "Tiedot, jotka lainanantaja kerää seuraavassa vaiheessa",
    "customerContactInfo": {
      "heading": "Yhteystiedot",
      "phone": "Puhelinnumero",
      "email": "Sähköposti"
    },
    "actions": {
      "nextStepCta": "Viimeistele ja vastaanota varat",
      "goToDashboard": {
        "title": "Haluatko katsoa saamiasi tarjouksia uudelleen?",
        "titleEligibleForPaymentNoLink": "Haluatko nähdä kaikki tarjoukset ja jatkaa toisen lainantarjoajan kanssa?",
        "titleEligibleForPaymentWithLink": "Haluatko nähdä kaikki tarjoukset uudelleen?",
        "buttonText": "Takaisin"
      },
      "createNewApplication": {
        "title": "Haluatko luoda uuden hakemuksen?",
        "buttonText": "Luo uusi hakemus"
      }
    },
    "lastStep": "Viimeinen vaihe:",
    "onboardAndProvideInformation": "Jatka {{lenderCompanyName}}-verkkosivustolla ja täytä lopulliset tiedot.",
    "allInformationProvided": "Olet antanut kaikki vaadittavat tiedot",
    "lenderWillReviewYourApplication": "Lainanantaja tarkistaa hakemuksesi ja palaa pian asiaan",
    "faq": {
      "processSteps": {
        "title": "Millainen on lainanantajan maksuprosessi?",
        "list": {
          "withLinkToLender": {
            "step1": "Siirry lainanantajan palveluun jatkaaksesi hakemusta: <a>Jatka lainanantajan verkkosivustolla</a>",
            "step2": "Lainanantaja tarkistaa tietosi ja kysyy tarvittavat lisätiedot lopullista luottopäätöstä varten",
            "step3": "Lainanantaja lähettää sopimuksen allekirjoitettavaksi ja maksaa varat tilillesi"
          },
          "withoutLinkToLender": {
            "step1": "Lainanantaja käsittelee hakemuksesi",
            "step2": "Lainanantaja pyytää tarvittaessa lisätietoja lopullista luottopäätöstä varten",
            "step3": "Lainanantaja lähettää sopimuksen allekirjoitettavaksi ja siirtää varat tilillesi"
          }
        }
      },
      "explanation": {
        "title": "Kuinka kauan rahoituksen saamisessa kestää?",
        "text": "Keskimäärin hakemuksen lähettämisestä varojen saamiseen kestää 3-10 päivää. Pienemmät summat maksetaan yleensä 1-3 päivän sisällä."
      }
    },
    "paidOut": {
      "title": "Kiitos, että käytit palveluamme",
      "subtitle": "Tietojemme mukaan olet vastaanottanut varat"
    }
  },
  "bidSelected": {},
  "factoringBidSelected": {},
  "realEstateBidSelected": {},
  "delegateFieldRequest": {
    "inviteHeading": "Anna kutsuttavan henkilön sähköpostiosoite tietojen lisäämiseksi.",
    "personsWithAccessTitle": "Ihmiset, joilla on pääsy tähän kysymykseen:",
    "revokeAccess": "Poista",
    "revokeAccessTooltip": "Poistaa tämän henkilön pääsyn kysymykseen",
    "ctaButton": "Lähetä linkki sähköpostiin",
    "validation": {
      "invalidEmail": "Anna kelvollinen sähköpostiosoite."
    },
    "uploadLater": {
      "heading": "Lähetä linkki sähköpostiisi, jotta voit jakaa tiedot myöhemmin",
      "ctaButton": "Lähetä linkki sähköpostiisi",
      "linkWillBeSent": "Lähetämme linkin kirjanpitotietojen lataamista varten antamaasi sähköpostiosoitteeseen",
      "helperPrompt": "Eikö tietoja ole nyt saatavilla? <trigger>Lähetä itsellesi sähköposti ladataksesi myöhemmin</trigger>",
      "modalTitle": "Lataa myöhemmin"
    }
  },
  "footer": {
    "heading": "Ota yhteyttä",
    "phoneLabel": "Puhelinnumero:",
    "emailLabel": "Sähköposti:",
    "addressLabel": "Osoite:",
    "openingHours": "Asiakaspalvelun aukioloajat",
    "mondayToThursdayLabel": {
      "FI": "Maanantai-Perjantain"
    },
    "fridayLabel": "Perjantain"
  },
  "cookieConsentThirdPartyApp": {
    "consent_modal": {
      "description": "Käytämme evästeitä palvelumme toiminnan takaamiseksi ja käyttökokemuksesi parantamiseksi. Jaamme myös dataa mainoskumppaneidemme kanssa.",
      "secondary_btn": {
        "text": "Hallinnoi evästeitä",
        "role": "settings"
      },
      "primary_btn": {
        "text": "Hyväksy kaikki",
        "role": "accept_all"
      }
    },
    "settings_modal": {
      "title": "Evästeasetukset",
      "save_settings_btn": "Tallenna asetukset",
      "accept_all_btn": "Hyväksy kaikki",
      "close_btn_label": "Close",
      "blocks": [
        {
          "description": "Käytämme evästeitä varmistaaksemme palvelumme perustoiminnot ja parantaaksemme käyttökokemustasi. Voit itse määrittää, mitkä evästeet tallennetaan verkkosivustollemme valitsemalla evästeluokat, jotka hyväksyt."
        },
        {
          "title": "Välttämättömät evästeet",
          "description": "Nämä evästeet ovat välttämättömiä verkkosivustomme oikeanlaisen toiminnan kannalta. Ilman näitä evästeitä verkkosivusto ei toimisi kunnolla, eikä niitä siksi voi laittaa pois.",
          "toggle": {
            "value": "necessary",
            "enabled": true,
            "readonly": true
          }
        },
        {
          "title": "Suorituskyky ja analytiikka",
          "description": "Nämä evästeet tallentavat tietoja verkkosivustomme käytöstä ja auttavat meitä parantamaan tuotteitamme.",
          "toggle": {
            "value": "analytics_storage",
            "enabled": false,
            "readonly": false
          }
        },
        {
          "title": "Markkinointi ja Personointi",
          "description": "Näitä evästeitä käytetään parantamaan kokemustasi verkkosivustollamme ja markkinointitarkoituksiin. Jakamalla nämä tiedot markkinointikumppaneidemme, kuten Googlen ja Microsoftin kanssa, voimme näyttää sinulle merkityksellisempää tietoa ja mainoksia. Evästeet auttavat meitä analysoimaan vuorovaikutusta verkkosivuillamme ja luomaan henkilökohtaisemman kokemuksen, joka mahdollistaa sisällön ja tarjousten räätälöinnin mieltymyksesi ja kiinnostuksenkohteidesi mukaan.",
          "toggle": {
            "value": "ad_storage",
            "enabled": false,
            "readonly": false
          }
        }
      ]
    }
  },
  "remoteIdentification": {
    "factoringLabel": "Laskurahoitus",
    "leasingLabel": "Leasing-rahoitus kohteelle",
    "reasonLabelSMS": "Syy",
    "ssnLabelSMS": "Syötä henkilötunnus",
    "SMSIdentifyKrea": "",
    "SMSIdentifyKredita": "Tunnista asiakas Kreditalla",
    "toastText": "Tunnista asiakas, jotta voimme varmistaa, että hänellä on allekirjoitusoikeudet yrityksessä",
    "identifyYourself": "Tunnistaudu",
    "customerView": "Asiakkaan näkymä",
    "product": "Tuote",
    "copyShareableLink": "Kopioi jaettava linkki",
    "copiedLink": "Kopioitu!",
    "linkExpires": "Linkki vanhenee: {{expiryDate}}",
    "fraudClientErrorPage": {
      "title": "Hakemusta ei saatu luotua.",
      "description": "Uuden hakemuksen tekeminen on estetty.",
      "descriptionNewLine": "Jos et ole tietoinen tästä ja uskot, että estoon ei ole syytä, olethan meihin yhteydessä."
    },
    "genericErrorPage": {
      "title": "Jokin meni pieleen.",
      "description": "Kokeile uudestaan tai ole yhteydessä asiakaspalveluumme. Kiitos!"
    }
  },
  "reviewProvider": {
    "google": {
      "numberOfReviews": "{{numberOfReviews}} arvostelua"
    },
    "reviews": "arvostelua",
    "trustpilotWidget": {
      "grade": "Erinomainen"
    },
    "officialFinancingPartner": "Virallinen rahoituskumppani",
    "trustMessage": "{{company}} on auttanut yli {{businessCount}} yritystä löytämään parhaan rahoitusratkaisun"
  },
  "applicationProgress": {
    "title": "Hakemuksen edistyminen",
    "tabs": {
      "progress": "Hakemuksen edistyminen",
      "aiAssistant": "Tekoälyavustin"
    },
    "step1": {
      "label": "Yhteystiedot"
    },
    "step2": {
      "label": "Rahoitustarve ja tunnistautuminen",
      "substep1": "Käyttötarkoitus",
      "substep2": {
        "default": "Summa",
        "objectFinancing": "Osto-/leasingtarpeet",
        "invoiceFinancing": "Rahoitettavien laskujen tiedot",
        "realEstate": "Tiedot kiinteistöstä"
      },
      "substep3": "Tunnistautuminen"
    },
    "step3": {
      "label": "Tärkeimmät tiedot",
      "sidebarLabels": {
        "reason_explanation": "Kuvaile tarpeesi",
        "grouped_real_estate_repayment": "Takaisinmaksusuunnitelma",
        "self_estimated_historic_revenue": "Arvioitu liikevaihto"
      }
    },
    "step4": {
      "label": "Lähetä ja saa tarjouksia"
    },
    "postSubmitTitle": "Vastaanota tarjouksia",
    "substep": {
      "skipped": "Ohitettu"
    },
    "collapse": "Piilota",
    "expand": "Näytä",
    "resizeSidebar": "Muuta sivupalkin leveyttä",
    "completed": "Valmis",
    "completedStepTooltip": "Voit vielä muokata tietojasi ennen hakemuksen lähettämistä",
    "editApplication": "Muokkaa hakemustasi",
    "editApplicationPartner": "Muokkaa asiakkaan hakemusta"
  },
  "postSubmitProgress": {
    "step1": {
      "label": "Hakemus"
    },
    "step2": {
      "label": "Tarjoukset",
      "tooltip": {
        "locked": "Saatavilla, kun hakemus on lähetetty rahoittajille"
      }
    },
    "step3": {
      "label": "Valittu tarjous",
      "tooltip": {
        "locked": "Saatavilla, kun olet valinnut tarjouksen"
      }
    },
    "verification": {
      "label": "{{company}}n tarkistus"
    },
    "improveApplication": {
      "label": "Tee parannuksia hakemukseesi"
    },
    "advice": {
      "label": "Neuvontapalvelu"
    }
  },
  "leaveReview": {
    "heading": "Oletko tyytyväinen {{company}}n palveluihin?",
    "subtext": "Jaa kokemuksesi ja auta muita löytämään sopiva rahoitus.",
    "reviews": "arvostelut",
    "google": {
      "cta": "Jätä Google-arvostelu"
    },
    "trustpilot": {
      "cta": "Jätä Trustpilot-arvostelu"
    }
  },
  "triageFields": {
    "toastTexts": {
      "reasonExplanation": {
        "title": "Ennen kuin lähetät hakemuksen",
        "subtitle": "Tunnistimme {{numberOfQuestions}} valinnaista kysymystä, jotka voivat auttaa saamaan parempia tarjouksia"
      },
      "refinancingAmounts": {
        "title": "Valitsit lainan uudelleenrahoitukseen liittyvän syyn.",
        "subtitle": "Jos yrityksesi haluaa maksaa takaisin olemassa olevaa rahoitusta, lisää tiedot alla."
      },
      "leasingAdditionalData": {
        "title": "Täytä alla olevat tiedot, niin saat myös leasingtarjouksia",
        "subtitle": "Leasing voi olla joustava tapa rahoittaa ajoneuvoja tai laitteita sitomatta suuria määriä pääomaa heti alkuun. Jos ohitat tämän vaiheen, saat silti normaalisti tarjouksia yrityslainoista."
      },
      "guarantors": {
        "title": "Yritykset, jotka tarjoavat yhden tai useamman takaajan, saavat kolme kertaa todennäköisemmin lainaa.",
        "subtitle": ""
      }
    }
  }
}
